/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Image_Models_EmptyInputs */



/**
* | output |
* | --- |
* | "No image models match your search." |
*
* @param {Org_Image_Models_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_image_models_empty = /** @type {((inputs?: Org_Image_Models_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Image_Models_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Bildmodelle passen zu Ihrer Suche.")
	return /** @type {LocalizedString} */ ("No image models match your search.")
});